import React from "react";

// Spinner reutilizable para las pantallas de "cargando docentes" (Colegio,
// CDA, Kindergarten) — antes cada una mostraba solo un texto plano, a veces
// en negro sobre un fondo oscuro, casi invisible.
const CargandoSpinner = ({ texto = "Cargando...", color = "#2563eb" }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "60px 20px",
      gap: 16,
    }}
  >
    <div
      style={{
        width: 46,
        height: 46,
        borderRadius: "50%",
        border: `4px solid ${color}33`,
        borderTopColor: color,
        animation: "cargando-spinner-girar 0.8s linear infinite",
      }}
    />
    <p style={{ margin: 0, fontSize: 14, fontWeight: 700, color, opacity: 0.9 }}>{texto}</p>

    <style>
      {`
        @keyframes cargando-spinner-girar {
          to { transform: rotate(360deg); }
        }
      `}
    </style>
  </div>
);

export default CargandoSpinner;
